import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

import BaseOrderView from './BaseOrderView';

const headers = strings.dataViewing.individualTradeViewRows;

const GRID_COLUMNS = [
  {
    field: 'instrumentId',
    columnHeader: headers.instrumentId,
    width: '12em',
    sortable: true
  },
  {
    field: 'tradeDate',
    columnHeader: headers.tradeDate,
    width: '11em',
    sortable: true,
    sortConfig: { direction: 'DESC'}
  },
  {
    field: 'price',
    columnHeader: headers.price,
    width: '7em',
    sortable: true
  },
  {
    field: 'priceCondition',
    columnHeader: headers.priceCondition,
    width: '8em',
    required: false
  },
  {
    field: 'missingPrice',
    columnHeader: headers.missingPrice,
    width: '8em'
  },
  {
    field: 'currency',
    columnHeader: strings.dataViewing.tableHeaders.currency,
    width: '5.5em',
    sortable: true
  },
  {
    field: 'vol',
    columnHeader: headers.vol,
    width: '7em'
  },
  {
    field: 'priceNot',
    columnHeader: headers.priceNot,
    width: '5em'
  },
  {
    field: 'publicationDate',
    columnHeader: headers.publicationDate,
    width: '12em'
  },
  {
    field: 'transactionID',
    columnHeader: headers.transactionID,
    width: '8em'
  },
  {
    field: 'notionalAmt',
    columnHeader: headers.notionalAmt,
    width: '12em'
  },

  {
    field: 'notionalCcy',
    columnHeader: headers.notionalCcy,
    width: '4em'
  },

  {
    field: 'flags',
    columnHeader: headers.flags,
    width: '12em'
  },
  {
    field: 'qtyMeasUnit',
    columnHeader: headers.qtyMeasUnit,
    width: '5em'
  },

  {
    field: 'type',
    columnHeader: headers.type,
    width: '5em'
  },
  {
    field: 'cleared',
    columnHeader: headers.cleared,
    width: '5em'
  },
  {
    field: 'thirdCountryExecutionVenue',
    columnHeader: headers.thirdCountryExecutionVenue,
    width: '12em'
  },
  // New fields added below
  {
    field: 'effectiveDateOfContract',
    columnHeader: 'Effective Date of Contract',
    width: '12em',
    required: false
  },
  {
    field: 'maturityDateOfContract',
    columnHeader: 'Maturity Date of Contract',
    width: '12em',
    required: false
  },
  {
    field: 'spread',
    columnHeader: 'Spread',
    width: '8em',
    required: false
  },
  {
    field: 'upfrontPayment',
    columnHeader: 'Upfront Payment',
    width: '10em',
    required: false
  },
  {
    field: 'clearingHouseLEI',
    columnHeader: 'Clearing House LEI',
    width: '12em',
    required: false
  },
  {
    field: 'totalNumberOfTransactions',
    columnHeader: 'No of Transactions',
    width: '8em',
    required: false
  },
  {
    field: 'tradingSystem',
    columnHeader: 'Trading System',
    width: '8em',
    require: false,
  },
  {
    field: 'isActual',
    columnHeader: '',
    width: '0em',
  }
];

const GRID_COLUMNS_UK = [
  {
    field: 'instrumentId',
    columnHeader: headers.instrumentId,
    width: '12em',
    sortable: true
  },
  {
    field: 'tradeDate',
    columnHeader: headers.tradeDate,
    width: '11em',
    sortable: true,
    sortConfig: { direction: 'DESC'}
  },
  {
    field: 'price',
    columnHeader: headers.price,
    width: '7em'
  },
  {
    field: 'priceCondition',
    columnHeader: headers.priceCondition,
    width: '8em',
    required: false
  },
  {
    field: 'currency',
    columnHeader: strings.dataViewing.tableHeaders.currency,
    width: '5.5em',
    sortable: true
  },
  {
    field: 'vol',
    columnHeader: headers.vol,
    width: '7em'
  },
  {
    field: 'priceNot',
    columnHeader: headers.priceNot,
    width: '5em'
  },
  {
    field: 'publicationDate',
    columnHeader: headers.publicationDate,
    width: '12em'
  },
  {
    field: 'transactionID',
    columnHeader: headers.transactionID,
    width: '8em'
  },
  {
    field: 'notionalAmt',
    columnHeader: headers.notionalAmt,
    width: '12em'
  },

  {
    field: 'notionalCcy',
    columnHeader: headers.notionalCcy,
    width: '4em'
  },

  {
    field: 'flags',
    columnHeader: headers.flags,
    width: '12em'
  },
  {
    field: 'qtyMeasUnit',
    columnHeader: headers.qtyMeasUnit,
    width: '5em'
  },

  {
    field: 'type',
    columnHeader: headers.type,
    width: '5em'
  },
  {
    field: 'cleared',
    columnHeader: headers.cleared,
    width: '5em'
  },
  {
    field: 'thirdCountryExecutionVenue',
    columnHeader: headers.thirdCountryExecutionVenue,
    width: '12em'
  },
  // New fields added below
  {
    field: 'effectiveDateOfContract',
    columnHeader: 'Effective Date of Contract',
    width: '12em',
    required: false
  },
  {
    field: 'maturityDateOfContract',
    columnHeader: 'Maturity Date of Contract',
    width: '12em',
    required: false
  },
  {
    field: 'spread',
    columnHeader: 'Spread',
    width: '8em',
    required: false
  },
  {
    field: 'upfrontPayment',
    columnHeader: 'Upfront Payment',
    width: '10em',
    required: false
  },
  {
    field: 'clearingHouseLEI',
    columnHeader: 'Clearing House LEI',
    width: '12em',
    required: false
  },
  {
    field: 'totalNumberOfTransactions',
    columnHeader: 'No of Transactions',
    width: '8em',
    required: false
  },
  {
    field: 'isActual',
    columnHeader: '',
    width: '0em',
  }
];


class TradeDisplayView extends Component {
  render() {
    //const isUkVenueAndEquityAssetClass =
    //      this.props.order.venueLocation === "UK" && this.props.order.assetClass === "Equity & Equity-like";

    const columns = this.props.order.venueLocation === "UK" ? GRID_COLUMNS_UK : GRID_COLUMNS;

    return (
      <BaseOrderView
        id="tradeDisplayView"
        tradeDisplay={true}
        showExpandCollapse={true}
        gridColumns={columns}
        {...this.props}
      />
    );
  }
}

export default TradeDisplayView;



// WEBPACK FOOTER //
// ./src/containers/DataViewing/orderViews/TradeDisplayView.jsx